import Colors from "Constants/Color";
import { tableStyles } from "Constants/Style";
import { Axios } from "api/axios";
import CancelBackButton from "components/Buttons/CancelBackButton";
import FormHeader from "components/Form&DetailsHeader/Form&DetailsHeader";
import FormattedDateTime from "components/FormattedDateTime/FormattedDateTime";
import PageContainer from "components/PageContainer/PageContainer";
import TruncatedTextCell from "components/TruncatedTextCell/TruncatedTextCell";
import { api } from "helpers/api_url";
import FilePreviewModal from "pages/Warehouse/ItemInward2/GRNDetails/FilePreviewModal/FilePreviewModal";
import React, { useEffect, useState } from "react";
import { Col, Form, Row, Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
// import ViewBagsModal from "./ViewBagsModal";

interface DispatchFormValues {
  dispatch_date_and_time: string;
  order_no: string;
  invoice_no: string;
  issue_from: any;
  upload_document: File | null;
  existing_document_file: string | null; // Store existing document URL for edit mode
  remark: string;
}

const DispatchViewDetails: React.FC = () => {
  const navigate = useNavigate();
  const { dispatch_id } = useParams<{ dispatch_id?: string }>();
  const dispatch = useDispatch<any>();
  const [data, setData] = useState<any>({});
  const isEdit = false;
  // Check if we're in edit mode (ID in URL params)
  const [isLoadingInitialData, setIsLoadingInitialData] = useState(true);
  const [showPreview, setShowPreview] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await Axios.get(
          `${api?.warehouse?.dispatch?.dispatch_done?.dispatch_by_id_for_view}/${dispatch_id}/view`
        );
        setData(result?.data?.data || {});
      } catch (error) {
        toast.error("Failed to fetch Dispatch Data");
        console.log("Error while fetching API", error);
      } finally {
        setIsLoadingInitialData(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <PageContainer>
        <FormHeader
          title={"View Details"}
          firstLabel="Dispatch"
          secondLabel={isEdit ? "Edit Dispatch" : "View Details"}
          handleArrowClick={() => navigate("/warehouse-dispatch")}
        />

        {isLoadingInitialData ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div>
            <hr />
            <h6
              className="mb-3"
              style={{ fontWeight: "600", color: "#212529" }}
            >
              Dispatch Details
            </h6>
            <Row
              className="mb-2"
              style={{ marginLeft: "3px", marginTop: "2px" }}
            >
              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Dispatch ID :</strong> {data?.dispatch_number || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Dispatch Date :</strong>{" "}
                  <FormattedDateTime dateString={data?.dispatch_date} format="date-only" />
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Dispatch By :</strong>{" "}
                  {data?.created_by_user?.username || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Order No :</strong> {data?.order_no || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Invoice No :</strong> {data?.invoice_no || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Issue From :</strong>{" "}
                  {data?.issued_from_warehouse?.warehouse_name || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Document Uploaded :</strong>{" "}
                  {data?.document ? (
                    <button
                      onClick={() => setShowPreview(true)}
                      style={{
                        color: "blue",
                        cursor: "pointer",
                        background: "none",
                        border: "none",
                        padding: 0,
                        textDecoration: "underline",
                      }}
                    >
                      View
                    </button>
                  ) : (
                    "No Document"
                  )}
                </p>

                <FilePreviewModal
                  show={showPreview}
                  onClose={() => setShowPreview(false)}
                  url={data?.document}
                />
              </Col>
            </Row>

            <hr />
            <div className="mb-3">
              <h6
                className="mb-3"
                style={{ fontWeight: "600", color: "#212529" }}
              >
                Customer Details
              </h6>
              <div
                style={{
                  backgroundColor: Colors?.background_color,
                  padding: "0 15px",
                  borderRadius: "8px",
                  border: `1px solid ${Colors?.background_color}`,
                }}
              >
                <Row className="mb-0 mt-3">
                  <Col lg={3}>
                    <p className="mb-3">
                      <strong>Customer Name :</strong>{" "}
                      {data?.customer_details?.customer_name || "-"}
                    </p>
                  </Col>

                  <Col lg={3}>
                    <p className="mb-3">
                      <strong>Customer Name for Transport :</strong>{" "}
                      {data?.customer_details?.customer_name_for_transport ||
                        "-"}
                    </p>
                  </Col>

                  <Col lg={3}>
                    <p className="mb-3">
                      <strong>Transporter Name :</strong>{" "}
                      {data?.customer_details?.transporter_name || "-"}
                    </p>
                  </Col>

                  <Col lg={3}>
                    <p className="mb-3">
                      <strong>Contact Person Name :</strong>{" "}
                      {data?.customer_details?.contact_person_name || "-"}
                    </p>
                  </Col>

                  <Col lg={3}>
                    <p className="mb-3">
                      <strong>Contact Number :</strong>{" "}
                      {data?.customer_details?.contact_number || "-"}
                    </p>
                  </Col>

                  <Col lg={3}>
                    <p className="mb-3">
                      <strong>Address :</strong>{" "}
                      {data?.customer_details?.address || "-"}
                    </p>
                  </Col>

                  <Col lg={3}>
                    <p className="mb-3">
                      <strong>City :</strong>{" "}
                      {data?.customer_details?.city || "-"}
                    </p>
                  </Col>

                  <Col lg={3}>
                    <p className="mb-3">
                      <strong>State :</strong>{" "}
                      {data?.customer_details?.state || "-"}
                    </p>
                  </Col>

                  <Col lg={3}>
                    <p className="mb-3">
                      <strong>Country :</strong>{" "}
                      {data?.customer_details?.country || "-"}
                    </p>
                  </Col>

                  <Col lg={3}>
                    <p className="mb-3">
                      <strong>Pincode :</strong>{" "}
                      {data?.customer_details?.pincode || "-"}
                    </p>
                  </Col>
                </Row>
              </div>
            </div>
            <hr />
            <div className="mb-3">
              <h6
                className="mb-3"
                style={{ fontWeight: "600", color: "#212529" }}
              >
                Item Details
              </h6>
              <div className="mb-2">
                <Table hover responsive className="align-middle text-center">
                  <thead>
                    <tr>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "80px" }}
                      >
                        Sr No.
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Dispatch Item Status
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Items
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Item Code
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Category
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Sub Category
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Unit
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Bag No.
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Order Qty
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Dispatch Qty
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Rate
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Amount
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Discount
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Discount Amount
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        GST%
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        GST Amount
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Total Amount
                      </th>
                      <th
                        style={{ ...tableStyles.headerAlt, minWidth: "150px" }}
                      >
                        Remarks
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {data?.dispatch_items?.length === 0 ? (
                      <tr>
                        <td
                          colSpan={18}
                          style={{ ...tableStyles.cell, textAlign: "center" }}
                          className="py-3"
                        >
                          No Items added. Please add at least one item.
                        </td>
                      </tr>
                    ) : (
                      data?.dispatch_items?.map((row: any, idx: number) => {
                        return (
                          <tr key={idx}>
                            <td style={tableStyles.cell}>{idx + 1}</td>
                            <td style={tableStyles.cell}>
                              {row?.dispatch_item_status
                                ? row.dispatch_item_status
                                    .toLowerCase()
                                    .split(" ")
                                    .map(
                                      (word: string) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1).toLowerCase()
                                    )
                                    .join(" ")
                                : "-"}
                            </td>

                            {/* Items */}
                            <td style={tableStyles.cell}>
                              {row?.item_name || "-"}
                            </td>

                            {/* Item Code */}
                            <td style={tableStyles.cell}>
                              {row?.item_code || "-"}
                            </td>

                            {/* Category */}
                            <td style={tableStyles.cell}>
                              {row?.category_name || "-"}
                            </td>

                            {/* Sub Category */}
                            <td style={tableStyles.cell}>
                              {row?.sub_category_name || "-"}
                            </td>

                            {/* Unit */}
                            <td style={tableStyles.cell}>
                              {row?.unit_name || row?.unit || "-"}
                            </td>

                            {/* Bag No. */}
                            <td style={tableStyles.cell}>
                              {row?.bags?.length > 0
                                ? row.bags.map((b: any) => b?.bag_no).join(", ")
                                : "-"}
                            </td>

                            {/* Order Quantity */}
                            <td style={tableStyles.cell}>
                              {row?.order_quantity ||
                                row?.total_quantity ||
                                "-"}
                            </td>

                            {/* Dispatch Quantity */}
                            <td style={tableStyles.cell}>
                              {row?.dispatch_quantity || "-"}
                            </td>

                            {/* Rate */}
                            <td style={tableStyles.cell}>{row?.rate || "-"}</td>

                            {/* Amount */}
                            <td style={tableStyles.cell}>
                              {row?.amount || "-"}
                            </td>

                            {/* Discount% */}
                            <td style={tableStyles.cell}>
                              {row?.discount}
                              {row?.discount_type === "percentage" ? "%" : "₹"}
                            </td>

                            {/* Discount Amount */}
                            <td style={tableStyles.cell}>
                              {row?.discount_amount || 0}
                            </td>

                            {/* GST% */}
                            <td style={tableStyles.cell}>
                              {row?.gst_percent || "-"}
                            </td>

                            {/* GST Amount */}
                            <td style={tableStyles.cell}>
                              {row?.gst_amount || "-"}
                            </td>

                            {/* Total Amount */}
                            <td style={tableStyles.cell}>
                              {row?.total_amount || "-"}
                            </td>

                            {/* Remarks */}
                            <td className="remark-cell" style={tableStyles.cell}>
                              <TruncatedTextCell
                                text={row?.remarks || row?.remark}
                                maxWidth="300px"
                                maxLines={4}
                                rowIndex={idx}
                                fallbackText="-"
                              />
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
            <Row className="mb-4">
              <Col lg={7} className="mb-3">
                <div
                  style={{
                    border: `1px solid ${Colors?.background_color}`,
                    borderRadius: "4px",
                  }}
                >
                  <div
                    className="d-flex align-items-center gap-2 mb-0 py-2 px-1"
                    style={{ background: Colors?.background_color }}
                  >
                    <i
                      className="bi bi-chevron-down"
                      style={{ fontSize: "0.675rem", color: "#000" }}
                    ></i>
                    <h6 className="mb-0">Remark</h6>
                  </div>

                  <Form.Control
                    as="textarea"
                    rows={7}
                    value={data?.remark || "-"} // ⬅️ direct value
                    readOnly // ⬅️ view-only mode
                    style={{
                      border: "1px solid transparent",
                      borderRadius: "0px",
                      resize: "none",
                      backgroundColor: "#f8f9fa",
                      color: "#000",
                    }}
                  />
                </div>
              </Col>

              <Col lg={5} className="mb-3">
                <div
                  style={{
                    backgroundColor: Colors?.background_color,
                    padding: "20px",
                    borderRadius: "8px",
                    border: `1px solid ${Colors?.background_color}`,
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Subtotal (Before Discount):
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.subtotal_before_total)?.toFixed(2)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Total Item Discounts:
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.total_item_discounts)?.toFixed(2)}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Net Taxable Value:
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.net_taxable_value)?.toFixed(2)}
                    </span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span style={{ fontSize: "0.875rem", color: "#212529" }}>
                      Total GST:
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.total_gst)?.toFixed(2)}
                    </span>
                  </div>

                  <hr style={{ margin: "12px 0", borderColor: "#90caf9" }} />

                  <div className="d-flex justify-content-between align-items-center">
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "600",
                        color: "#212529",
                      }}
                    >
                      Total Amount:
                    </span>
                    <span
                      style={{
                        fontSize: "1rem",
                        fontWeight: "700",
                        color: "#212529",
                      }}
                    >
                      ₹ {Number(data?.total_amount)?.toFixed(2)}
                    </span>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="d-flex justify-content-center gap-3 py-3">
              <CancelBackButton
                label="Back"
                onClick={() => {
                  navigate("/warehouse-dispatch");
                }}
              />
            </div>
          </div>
        )}
      </PageContainer>
    </>
  );
};

export default DispatchViewDetails;
